import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function TimelineSkeleton() {
    return <Skeleton height={140} />;
}
